export default class User {
    constructor(username, email, password, tenant_id, two_factor_code) {
      this.username = username;
      this.email = email;
      this.password = password;
      this.tenant_id = tenant_id;
      this.two_factor_code = two_factor_code;
    }
  }